module.exports = __webpack_public_path__ + "media/images/homebeat-tiny-43ee3edd.svg";